import { render, staticRenderFns } from "./companyinformation.vue?vue&type=template&id=5f8443ba&"
import script from "./companyinformation.vue?vue&type=script&lang=ts&"
export * from "./companyinformation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "companyinformation.vue"
export default component.exports